import * as React from 'react';
import { NavigatorSection, UnauthorizedNavigatorSection } from './Navigator';
import SettingsIcon from '@material-ui/icons/Settings';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import HomeIcon from '@material-ui/icons/Home';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import HistoryIcon from '@material-ui/icons/History';

export enum ProductId {
  deltaJson = 'DeltaJSON'
}

export enum Operations {
  compare = 'Compare',
  twoWayMerge = 'Two Way Merge',
  threeWayMerge = 'Three Way Merge',
  graft = 'Graft',
  patch = 'Patch'
}

export interface OperationData {
  path: string,
  fileSuffix: string
}

export class NavigatorData {

  // convert 'ThreeWayMerge' to 'Three Way Merge'
  public static stringToOperation(opName: string) {
    const charBuffer: string[] = [];
    for (let i = 0; i < opName.length; i++) {
      const char = opName.charAt(i);
      const codePoint = opName.charCodeAt(i);
      if (codePoint < 97 && i > 0) {
        // capital letter so insert space:
        charBuffer.push(' ');
      }
      charBuffer.push(char);
    }
    return charBuffer.join('') as Operations;
  }

  public static title = 'DeltaJSON';

  private static fillOperationslMap() {
    const map: Map<Operations, OperationData> = new Map();
    map.set(Operations.compare, {path: '/compare', fileSuffix: 'cmp'});
    map.set(Operations.twoWayMerge, {path: '/two-way-merge', fileSuffix: 'mgd'});
    map.set(Operations.threeWayMerge, {path: '/three-way-merge', fileSuffix: 'mgt'});
    map.set(Operations.graft, {path: '/graft', fileSuffix: 'gft'});
    map.set(Operations.patch, {path: '/patch', fileSuffix: 'pch'});
    return map;
  }

  
  private static opsData = NavigatorData.fillOperationslMap();
  
  private static genPathsMap() {
    const newMap: Map<string, Operations> = new Map();
    this.opsData.forEach((value, key, m) => {
      let newPathKey = m.get(key)?.path;
      newPathKey = newPathKey? newPathKey : 'nul';
      newMap.set(newPathKey, key);
    });
    return newMap;
  }

  public static pathsData = NavigatorData.genPathsMap();

  public static getPathForOperation(op: Operations) {
    const opPath = NavigatorData.opsData.get(op)?.path
    return opPath? opPath : '/';
  }

  public static getSuffixForOperation(op: Operations) {
    const suffix = NavigatorData.opsData.get(op)?.fileSuffix
    return suffix? suffix : 'null';
  }

  public static getLinkRefForOperation(baseUrl: string, op: Operations) {
    return baseUrl + NavigatorData.getPathForOperation(op);
  }

  public static getOperationForPath(path: string): Operations {
    let op = NavigatorData.pathsData.get(path);
    op = op? op : Operations.compare;
    return op;
  }

  public static welcomBaseUrl = '/welcome';
  public static configBaseUrl = '/configuration';
  public static filesBaseUrl = '/files';
  public static logsBaseUrl = '/logs';
  // public static sessionJobsBaseUrl = '/sessionJobs';
  public static jobsHistoryBaseUrl = '/jobsHistory'
  // public static profileBaseUrl = '/profile';
  // public static pricingBaseUrl = '/store';
  public static callbackBaseUrl = '/callback';


  public static RootSections: NavigatorSection[] = [
    {
      id: "Control",
      children: [
        { id: 'Welcome', icon: <HomeIcon />, active: true, link: '/' },
        { id: 'Configuration', icon: <SettingsIcon />, link: NavigatorData.configBaseUrl },
        { id: 'Files', icon: <FindInPageIcon />, link: NavigatorData.filesBaseUrl },
        // { id: 'Session Jobs', icon: <TimelineIcon />, link: NavigatorData.sessionJobsBaseUrl },
        { id: 'Jobs History', icon: <HistoryIcon />, link: NavigatorData.jobsHistoryBaseUrl },
        { id: 'Logs', icon: <TrackChangesIcon />, link: NavigatorData.logsBaseUrl},
      ],
    },
    // {
    //   id: 'Manage',
    //   children: [
    //     { id: 'My Profile', icon: <AccountCircleIcon />, link: NavigatorData.profileBaseUrl },
    //     { id: 'Store', icon: <LocalGroceryStoreIcon />, link: NavigatorData.pricingBaseUrl },
    //   ],
    // },
  ];

  public static CompareSections: NavigatorSection[] = [
    {
      id: 'Compare',
      children: [
        { id: 'Compare', icon: <SettingsIcon />, active: true, link: '/compare' }
      ],
    },
  ];

  public static UnauthorizedSections: UnauthorizedNavigatorSection[] = [
    {
      id: "Control",
      children: [
        { id: 'Welcome', icon: <HomeIcon />, active: true, link: '/' },
      ],
    },
  ];
}